const API_ROOT = ''

async function request (path, options = {}) {
  const response = await fetch(API_ROOT + path, {
    credentials: 'same-origin',
    ...options,
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', ...(options.headers || {}) }
  })
  const payload = await response.json().catch(() => ({}))
  if (!response.ok || payload.err !== 0) throw new Error(payload.msg || payload.message || `暂未开放（${response.status}）`)
  return payload
}

export async function loginMember (credentials) {
  const data = await request('/index/login/loginbyname', {
    method: 'POST',
    body: new URLSearchParams(credentials).toString()
  })
  return { accessToken: 'php-cookie-session', user: { username: credentials.username, nickname: data.nickanme, balance: Number(data.money) } }
}

export async function getAccountSummary () {
  const data = await request('/web/login/checkLogin')
  return { nickname: data.nickname, balance: Number(data.money) }
}

export function logoutMember () { return request('/web/login/wap_logout') }

export function getLotteryCatalog () {
  return Promise.reject(new Error('暂未开放'))
}

export function getLotteryWallet (accessToken) {
  return Promise.reject(new Error('暂未开放'))
}

export function placeLotteryBet (accessToken, bet) {
  return Promise.reject(new Error('暂未开放'))
}
